import React, { useEffect, useState } from 'react';
import PuntosControlPorRonda from './PuntosControlPorRonda';
import MapaTrackingPorRonda from './MapaTrackingPorRonda';
import IncidenciasPorRonda from './IncidenciasPorRonda';
import { fetchPointControlsByYardApi } from '../../../services/api';
import { useAuth } from '../../../context/AuthContext';

const sectionsConfig = [
  { id: 'puntos', label: 'Puntos de control', component: PuntosControlPorRonda },
  { id: 'mapa', label: 'Mapa y tracking', component: MapaTrackingPorRonda },
  { id: 'incidencias', label: 'Incidencias', component: IncidenciasPorRonda },
];

export default function ModalReporteRondas({ show, onClose, round, assignment }) {
  const { token } = useAuth();
  const [activeSection, setActiveSection] = useState('puntos');
  const [pointControls, setPointControls] = useState([]);

  useEffect(() => {
    if (show) setActiveSection('puntos');
  }, [show]);

  useEffect(() => {
    let isMounted = true;

    const loadPointControls = async () => {
      if (!show || !assignment?.yardId) {
        setPointControls([]);
        return;
      }

      try {
        const data = await fetchPointControlsByYardApi(assignment.yardId, { token });
        if (isMounted) {
          setPointControls(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        console.error(err);
        if (isMounted) setPointControls([]);
      }
    };

    loadPointControls();

    return () => {
      isMounted = false;
    };
  }, [show, assignment?.yardId, token]);

  if (!show) return null;

  const ActiveComponent = sectionsConfig.find(section => section.id === activeSection)?.component || PuntosControlPorRonda;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-fullscreen modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header px-5">
              <h5 className="modal-title">Detalle de la ronda</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Cerrar"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="d-flex flex-column flex-md-row gap-3">
                <div className="d-flex flex-md-column gap-2 flex-shrink-0" style={{ minWidth: '200px' }}>
                  {sectionsConfig.map(section => (
                    <button
                      key={section.id}
                      type="button"
                      className={'btn w-100 text-start ' + (activeSection === section.id ? 'btn-primary' : 'btn-outline-primary')}
                      onClick={() => setActiveSection(section.id)}
                    >
                      {section.label}
                    </button>
                  ))}
                </div>
                <div className="flex-grow-1 border rounded p-3 bg-light">
                  <ActiveComponent
                    round={round}
                    assignment={assignment}
                    pointControls={pointControls}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}
